import { render, staticRenderFns } from "./ScoutingReportSpiderChart.vue?vue&type=template&id=2fcfdf11&scoped=true&"
import script from "./ScoutingReportSpiderChart.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportSpiderChart.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingReportSpiderChart.vue?vue&type=style&index=0&id=2fcfdf11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfdf11",
  null
  
)

export default component.exports